export const wrapperStyles = { display: 'flex', alignItems: 'center', gap: 1 };

export const calculatedStyles = { display: 'flex', alignItems: 'center', gap: '4px' };

export const struckThroughValueStyles = { textDecoration: 'line-through' };

export const revertButtonStyles = { typography: 'regular12' };
